export default __webpack_public_path__ + "static/logo_woocommerce-f177f46297aa053d2bd92c4e5d09df0d.jpg";